import { getShareButtonTemplate } from './functions/getShareButtonTemplate.js';
import styles from "./styles.module.scss";
import clsx from "classnames";
import PropTypes from "prop-types";
import {
    Card
} from 'reactstrap';

export default function SocialShare({
    className,
    pageTitle,
    pageUrl,
    blogPage,
    shareButtons = [
        'facebook',
        'twitter',
        'linkedin',
        'telegram',
        'whatsapp',
        'email']
}) {
    const handleClipboardClick = () => {
        navigator.clipboard.writeText(pageUrl).then(() => {
            alert('URL copied!');
        }).catch(err => {
            console.error('Could not copy text: ', err);
        });
    };

    return (
        <Card className={clsx(className, styles.root)}>
            {blogPage ?
                <>
                    {/* <div className='grey-text mb-2'>SHARE</div> */}
                    <div className='d-flex flex-wrap wrapper'>
                        {shareButtons.map(templateName => getShareButtonTemplate(templateName)(pageTitle, pageUrl))}
                        <button
                            className="border-0 p-0"
                            aria-label="Clipboard"
                            onClick={handleClipboardClick}
                        >
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="30" height="30" rx="15" fill="#FFCC33" />
                                <path d="M20.4167 15.2434C21.5947 14.0661 21.5947 12.1595 20.4167 10.9822C19.3743 9.94031 17.7314 9.80487 16.5326 10.6613L16.4992 10.6842C16.199 10.8988 16.1302 11.3156 16.3449 11.6135C16.5597 11.9115 16.9767 11.9824 17.2748 11.7677L17.3082 11.7448C17.9774 11.2676 18.8927 11.3427 19.4723 11.924C20.129 12.5804 20.129 13.6431 19.4723 14.2995L17.133 16.6416C16.4763 17.298 15.413 17.298 14.7563 16.6416C14.1746 16.0602 14.0995 15.1455 14.577 14.4787L14.5999 14.4453C14.8146 14.1453 14.7438 13.7285 14.4456 13.516C14.1475 13.3035 13.7284 13.3722 13.5158 13.6702L13.4928 13.7035C12.6339 14.8996 12.7694 16.5416 13.8118 17.5834C14.9898 18.7607 16.8974 18.7607 18.0754 17.5834L20.4167 15.2434ZM9.58367 14.7558C8.40571 15.9331 8.40571 17.8397 9.58367 19.017C10.6261 20.0589 12.269 20.1943 13.4678 19.3379L13.5012 19.315C13.8014 19.1004 13.8702 18.6836 13.6554 18.3857C13.4407 18.0877 13.0237 18.0169 12.7256 18.2315L12.6922 18.2544C12.023 18.7316 11.1077 18.6566 10.5281 18.0752C9.87138 17.4167 9.87138 16.354 10.5281 15.6977L12.8674 13.3576C13.5241 12.7013 14.5874 12.7013 15.2441 13.3576C15.8258 13.939 15.9009 14.8537 15.4234 15.5226L15.4005 15.556C15.1858 15.856 15.2566 16.2728 15.5548 16.4853C15.8529 16.6978 16.272 16.6291 16.4846 16.3311L16.5076 16.2978C17.3665 15.0996 17.231 13.4576 16.1886 12.4158C15.0106 11.2385 13.103 11.2385 11.925 12.4158L9.58367 14.7558Z" fill="black" />
                            </svg>
                        </button>

                    </div>
                </>
                :
                <>
                    {/* <div className='grey-text mb-2'>SHARE</div> */}
                    <div className='px-5 py-3 d-flex wrapper'>
                        {shareButtons.map(templateName => getShareButtonTemplate(templateName)(pageTitle, pageUrl))}
                    </div>
                </>}

        </Card>
    )
}

SocialShare.defaultProps = {
    className: "box mb-4",
    blogPage: false
};

SocialShare.propTypes = {
    className: PropTypes.string,
    blogPage: PropTypes.bool,
};